import React from 'react';
import { Typography } from '@mui/material';

/** F6b polish: "Serials: A, B, C" under a document line; renders nothing when the line moved no serials. */
const DocumentSerialsCaption: React.FC<{ serials?: string[] }> = ({ serials }) => {
  if (!serials || serials.length === 0) return null;
  return (
    <Typography variant="caption" color="text.secondary" component="div" data-testid="line-serials"
      sx={{ wordBreak: 'break-word' }}>
      Serials: {serials.join(', ')}
    </Typography>
  );
};

export default DocumentSerialsCaption;
